/* Fumer stock / back-order messaging.
   Dawn only swaps price, SKU, inventory and the submit button when the variant changes -
   custom blocks are left alone - so this keeps the stock line, the pickup widget and the
   button label in sync with whichever variant is selected.
   Data comes in as a quote-free attribute: "variantId:qty:available,variantId:qty:available". */
(function () {
  var IN_HTML =
    '<p class="fsc-stock fsc-stock--in"><strong>In stock at Annerley.</strong> On the shelf now &mdash; ' +
    'ready to collect in about 2 hours during shop hours, or dispatched same day on orders placed before 12PM.</p>';
  var BACK_HTML =
    '<p class="fsc-stock fsc-stock--back"><strong>On back order &mdash; not in the shop right now.</strong> ' +
    'Allow <strong>3&ndash;5 business days</strong> for this one to reach us. That applies to click &amp; collect ' +
    'as well as delivery, so please wait for your ready-for-pickup email before coming in.</p>';

  var BTN_IN = 'Add to cart';
  var BTN_BACK = 'Add to cart — back order';

  var map = null;
  var lastKey = null;

  function getMap() {
    if (map) return map;
    var el = document.getElementById('fsc-stock-data');
    if (!el) return null;
    var raw = el.getAttribute('data-map') || '';
    if (!raw) return null;
    map = {};
    var rows = raw.split(',');
    for (var i = 0; i < rows.length; i++) {
      var p = rows[i].split(':');
      if (p.length < 3) continue;
      map[p[0]] = { q: parseInt(p[1], 10), a: p[2] === '1' };
    }
    return map;
  }

  function currentVariantId() {
    var input = document.querySelector('.product-variant-id');
    if (input && input.value) return String(input.value);
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function paintSlot(inStock) {
    var slot = document.getElementById('fsc-stock-slot');
    if (!slot) return;
    slot.innerHTML = inStock ? IN_HTML : BACK_HTML;
  }

  function paintPickup(inStock) {
    var pickup = document.querySelector('pickup-availability');
    if (!pickup) return;
    var want = inStock ? '' : 'none';
    if (pickup.style.display !== want) pickup.style.display = want;
  }

  function paintButton(inStock, available) {
    var span = document.querySelector('.product-form__submit > span');
    if (!span || !available) return;
    var current = (span.textContent || '').trim();
    var lower = current.toLowerCase();
    if (lower.indexOf('sold out') !== -1 || lower.indexOf('unavailable') !== -1) return;
    var want = inStock ? BTN_IN : BTN_BACK;
    if (current !== want) span.textContent = want;
  }

  function tick() {
    var m = getMap();
    if (!m) return;
    var id = currentVariantId();
    if (!id) return;
    var v = m[id];
    if (!v) return;

    var inStock = v.q > 0;
    var key = id + ':' + (inStock ? '1' : '0');
    if (key !== lastKey) {
      paintSlot(inStock);
      lastKey = key;
    }
    paintPickup(inStock);
    paintButton(inStock, v.a);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; tick(); });
  }

  function boot() {
    tick();
    var scope = document.querySelector('product-info') || document.body;
    try {
      new MutationObserver(schedule).observe(scope, { childList: true, subtree: true, attributes: true });
    } catch (e) {}
    window.setInterval(tick, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();